import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LeafLogo } from "@/components/common/LeafLogo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";

const AdminLogin = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gmoaa-green px-4">
      <div className="w-full max-w-md rounded-2xl border border-gmoaa-gold/30 bg-gmoaa-cream p-8 shadow-xl">
        <div className="mb-6 flex flex-col items-center text-center">
          <LeafLogo size={64} />
          <h1 className="mt-4 font-serif text-2xl font-bold text-gmoaa-green">GMOAA Admin</h1>
          <p className="text-sm text-gmoaa-text-muted">Sign in to manage the website content</p>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <Label className="mb-1.5 block text-sm">Email</Label>
            <Input data-testid="admin-login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="border-gmoaa-border-subtle bg-white" />
          </div>
          <div>
            <Label className="mb-1.5 block text-sm">Password</Label>
            <Input data-testid="admin-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="border-gmoaa-border-subtle bg-white" />
          </div>
          {error && <p className="rounded-lg bg-gmoaa-red-bg px-3 py-2 text-sm text-gmoaa-red" data-testid="admin-login-error">{error}</p>}
          <Button data-testid="admin-login-submit" type="submit" disabled={busy} className="w-full bg-gmoaa-green text-white hover:bg-gmoaa-green-hover">
            <Lock size={16} className="mr-1.5" /> {busy ? "Signing in..." : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
